/**
 * Strips location suffixes, taglines, and descriptors from a raw GBP name.
 * "Thistle Media – Best Digital Marketing Agency in Bangalore | 16+ Years"
 *  → "Thistle Media"
 */
export const normalizeBrandName = (rawName = '') => {
  if (!rawName) return rawName;

  return rawName
    // 1. Cut at common separators: –, —, |, ·, •, /
    .split(/\s*[–—|·•\/]\s*/)[0]

    // 2. Cut at " - " (spaced hyphen used as separator)
    .split(/\s+-\s+/)[0]

    // 3. Strip trailing location phrases: "in Bangalore", "Bangalore Branch", etc.
    .replace(/\s+(in|at|near|@)\s+.+$/i, '')
    .replace(/\s*[-–,]\s*(bangalore|chennai|mumbai|delhi|hyderabad|pune|kolkata|noida|gurugram|gurgaon|india|usa|uk|dubai|singapore)\b.*/i, '')

    // 4. Strip branch/location suffixes: "- Koramangala", "(24 Hours)", "Branch"
    .replace(/\s*[-–,]\s*[A-Z][a-z]+(\s+[A-Z][a-z]+)*\s*$/,'')
    .replace(/\s*\(.*?\)\s*$/, '')
    .replace(/\s+branch\s*$/i, '')

    .trim();
};